export default function () {
  const deferred = {}
  deferred.promise = new Promise((resolve, reject) => {
    deferred.resolve = resolve
    deferred.reject = reject
  })
  return deferred
}



// WEBPACK FOOTER //
// ./src/helpers/create-deferred.js